import { render, staticRenderFns } from "./receivingAccountList.vue?vue&type=template&id=d543f252&scoped=true&"
import script from "./receivingAccountList.vue?vue&type=script&lang=js&"
export * from "./receivingAccountList.vue?vue&type=script&lang=js&"
import style0 from "./receivingAccountList.vue?vue&type=style&index=0&id=d543f252&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d543f252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d543f252', component.options)
    } else {
      api.reload('d543f252', component.options)
    }
    module.hot.accept("./receivingAccountList.vue?vue&type=template&id=d543f252&scoped=true&", function () {
      api.rerender('d543f252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/receivingAccountList.vue"
export default component.exports